import React from 'react';

const Chip = ({ label, selected, onClick, icon, style, size = 'md' }) => {
  const sizes = {
    sm: { padding: '6px 12px', fontSize: 12, borderRadius: 10 },
    md: { padding: '8px 16px', fontSize: 13, borderRadius: 12 },
    lg: { padding: '10px 20px', fontSize: 14, borderRadius: 14 },
  };

  return (
    <button onClick={onClick} style={{
      display: 'inline-flex', alignItems: 'center', gap: 6,
      background: selected ? 'rgba(255,61,113,0.15)' : 'rgba(255,255,255,0.04)',
      border: `1px solid ${selected ? 'rgba(255,61,113,0.4)' : 'rgba(255,255,255,0.08)'}`,
      color: selected ? '#FF3D71' : '#A1A1AA',
      cursor: 'pointer', fontFamily: 'Inter, sans-serif', fontWeight: 500,
      transition: 'all 0.2s ease',
      ...sizes[size],
      ...style,
    }}>
      {icon && <span>{icon}</span>}
      {label}
    </button>
  );
};

export default Chip;
